export default function useUploadCard({ fileList, props, emit }) {
  const remove = (file) => {
    console.log(file, 'remove')
    const resVal = fileList.value.filter((item) => item.url !== file.url)
    if (props.valueIsObj) {
      props.multiple ? emit('input', resVal) : emit('input', null)
    } else {
      props.multiple
        ? emit(
            'input',
            Object.values(resVal)
              .map((im) => im.url)
              .join(',')
          )
        : emit('input', null)
    }
  }
  const preview = (file) => {
    console.log(file, 'preview')
  }
  const download = (file) => {
    const link = document.createElement('a')
    link.style.display = 'none'
    link.download = file?.name
    link.href = file.url
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  return { preview, download, remove }
}
